import MenuOpenIcon from '@mui/icons-material/MenuOpen'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Link from '@mui/material/Link'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { MenuTab } from '~/components/Atoms/MenuTab'
import { MenuUser } from '~/components/Atoms/MenuUser'
import { NAV_LINKS } from '~/constants'

import { Drawer } from './Menu.styles'

import logo from '~/assets/logo-white.svg'
import { useUser } from '~/lib/auth'

export function Menu({ ...props }) {
  const user = useUser()
  const theme = useTheme()
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  const handleDrawerOpen = () => {
    setOpen(!open)
  }

  return (
    <Box display="flex">
      <Drawer variant="permanent" open={open}>
        <Box
          display="flex"
          alignItems={'center'}
          justifyContent={open ? 'space-between' : 'center'}
          width="100%"
          height={theme.size[19]}
          padding={`0 ${theme.spacing.L}`}
        >
          {open && <img width="96px" height="48px" src={logo} />}
          <IconButton onClick={handleDrawerOpen} sx={{ color: theme.palette.common.white }}>
            <MenuOpenIcon />
          </IconButton>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent={'space-between'}
          padding={`0 ${theme.spacing.L} ${theme.spacing['3XL']} ${theme.spacing.L} `}
          height="100%"
        >
          <Box display="flex" flexDirection="column" gap={theme.spacing.XS}>
            {Object.values(NAV_LINKS).map((link) => {
              if (!link.displayMenu) return null
              return <MenuTab key={link.to} label={t(link.label)} to={link.to} icon={link.icon} open={open} />
            })}
          </Box>
          <Box display="flex" flexDirection="column" gap={theme.spacing.XS}>
            <MenuUser name={user?.data?.name} email={user?.data?.email} open={open} />
            {open && (
              <Box display="flex" justifyContent="center">
                <Link
                  component={RouterLink}
                  to={NAV_LINKS.OSS_LICENSES.to}
                  variant="caption"
                  sx={{ color: theme.palette.common.white, opacity: 0.5, '&:hover': { opacity: 1 } }}
                >
                  {t('common:oss.licenses')}
                </Link>
              </Box>
            )}
          </Box>
        </Box>
      </Drawer>
      <Box sx={{ flexGrow: 1, display: 'flex', backgroundColor: theme.palette.primary.main, minHeight: '100vh' }}>
        {props.children}
      </Box>
      {/* <MUIDrawer variant="temporary" anchor="right" open={tempOpen} onClose={handleTempDrawerOpen}>
        <Box sx={{ width: 250, padding: 2 }}>
          <Typography variant="h6">Temporary Drawer</Typography>
          <Typography variant="body1">This is a temporary drawer that can be closed by clicking outside.</Typography>
        </Box>
      </MUIDrawer> */}
    </Box>
  )
}
